<template>
  <div class="hidden" data-qa="qa-translation-probe">
    {{ i18n(props.definition) }}
  </div>
</template>

<script setup>
import { useI18n } from "../composables/useI18n";
const i18n = useI18n();
const props = defineProps({
  definition: { type: Object, required: true }
});
</script>
